import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';

import OptionButton from './OptionButton';

const SubmitButton = ({ clickHandler, a11yAttributes }) => {
    return (<OptionButton
        isMainAction
        iconClass="fa fa-paper-plane-o fa-fw"
        clickHandler={clickHandler}
        title={t('options.submitNow')}
        a11yAttributes={a11yAttributes}
    />);
};

SubmitButton.propTypes = {
    clickHandler: PropTypes.func.isRequired,
    a11yAttributes: PropTypes.object,
};

export default SubmitButton;
